import { render } from "./Collaborators.vue?vue&type=template&id=39ebe242"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__